import React, { useRef, useState } from "react";
import ArrowTop from "../../../Common/svg/arrowtop";
import AddressInfo from "../addressInfo";
import { useQuery } from "react-query";
import { getDelivery } from "../../../../MyApi/delivery";
import EnhancedSearchStore from "../../../UI/enhancedstoresearch";
import PhoneInput from "../../../UI/phoneInput";
import PhoneField from "../../../UI/phoneInput";
import { toast } from "react-toastify";

const CuriorInfo = ({
  curiorInfo,
  setCuriorInfo,
  nationalID,
  setNationalID,
  addressInfo,
  setAddressInfo,
  mode,
  formErrors: errorsForm,
  handleBlur,
}) => {
  const avatarRef = useRef(null);
  const frontIdRef = useRef(null);
  const backIdRef = useRef(null);
  const [errors, setErrors] = useState({});
  const { data } = useQuery("getDelivery", getDelivery);
  const delivery_company = data?.data?.delivery_company || [];
  const setStoreId = (id) => {
    setCuriorInfo({ ...curiorInfo, store_id: id });
  };

  const handlePhoneChange = ({ phone, phone_code }) => {
    setCuriorInfo((prev) => ({
      ...prev,
      phone,
      phone_code,
    }));
  };

  const validateImage = (file) => {
    const maxSize = 12 * 1024 * 1024; // 12MB
    const validTypes = [
      "image/jpeg",
      "image/png",
      "image/jpg",
      "image/gif",
      "image/webp",
    ];

    if (!file) return false;

    if (file.size > maxSize) {
      toast.error("حجم الملف يجب ألا يتجاوز 12 ميجابايت");
      return false;
    }

    if (!validTypes.includes(file.type)) {
      toast.error("نوع الملف غير مدعوم. المسموح: JPG, PNG, GIF, WEBP");
      return false;
    }

    return true;
  };
const imageInstructions = {
  maxSize: "12MB",
  formats: "JPG, PNG, JPEG, GIF, WEBP",
};
  return (
    <div className="row">
      <h6 className="font16 mb-3">المعلومات الشخصية</h6>
      <h6 className="font16 mt-2">معلومات السائق</h6>
      <label className="form-label">اسم السائق</label>
      {/* الاسم الأول */}
      <div className="col-md-6">
        <label className="form-label">الاسم الأول</label>
        <input
          type="text"
          className={`form-control ${errorsForm?.first_name ? "is-invalid" : ""}`}
          placeholder="أدخل الاسم الأول"
          value={curiorInfo.first_name}
          onChange={(e) =>
            setCuriorInfo({ ...curiorInfo, first_name: e.target.value })
          }
          onBlur={handleBlur}
        />
        {errorsForm?.first_name && (
          <small className="invalid-feedback">{errorsForm.first_name}</small>
        )}
      </div>

      {/* الاسم الأخير */}
      <div className="col-md-6  ">
        <label htmlFor="" className="form-label">
          الاسم الأخير
        </label>
        <input
          type="text"
          className={`form-control ${errorsForm?.last_name ? "is-invalid" : ""}`}
          placeholder="أدخل الاسم الأخير للسائق"
          value={curiorInfo.last_name}
          onChange={(e) =>
            setCuriorInfo({ ...curiorInfo, last_name: e.target.value })
          }
        />
        {errorsForm?.last_name && (
          <small className="invalid-feedback">{errorsForm.last_name}</small>
        )}
      </div>

      <PhoneField
        onChange={handlePhoneChange}
        phone={curiorInfo.phone}
        phone_code={curiorInfo.phone_code}
        setErrors={setErrors}
      />

      {errorsForm?.phone && (
        <small className="d-block invalid-feedback">{errorsForm.phone}</small>
      )}
      {errorsForm?.phone_code && (
        <small className="d-block  invalid-feedback">
          {errorsForm.phone_code}
        </small>
      )}
      {/* الإيميل */}
      <div className="col-md-6">
        <label className="form-label">الإيميل</label>
        <input
          type="email"
          className={`form-control ${errorsForm?.email ? "is-invalid" : ""}`}
          value={curiorInfo.email}
          onChange={(e) =>
            setCuriorInfo({ ...curiorInfo, email: e.target.value })
          }
        />
        {errorsForm?.email && (
          <small className="d-block  invalid-feedback">
            {errorsForm.email}
          </small>
        )}
      </div>

      {/* رقم الهوية */}
      <div className="col-md-6">
        <label className="form-label">رقم الهوية</label>
        <input
          type="text"
          className={`form-control ${errorsForm?.email ? "is-invalid" : ""}`}
          value={nationalID.national_id}
          onChange={(e) =>
            setNationalID({
              ...nationalID,
              national_id: e.target.value,
            })
          }
        />
        {errorsForm?.national_id && (
          <small className="d-block  invalid-feedback">
            {errorsForm.national_id}
          </small>
        )}
      </div>
      {/* رقم الرخصة */}
      <div className="col-md-6">
        <label className="form-label">رقم الرخصة</label>
        <input
          type="text"
          className={`form-control ${errorsForm?.license_number ? "is-invalid" : ""}`}
          value={curiorInfo.license_number}
          onChange={(e) =>
            setCuriorInfo({
              ...curiorInfo,
              license_number: e.target.value,
            })
          }
        />
        {errorsForm?.license_number && (
          <small className="d-block invalid-feedback">
            {errorsForm.license_number}
          </small>
        )}
      </div>

      {/* تاريخ الميلاد */}
      <div className="col-md-6">
        <label className="form-label">تاريخ الميلاد</label>
        <input
          type="date"
          className={`form-control ${errorsForm?.birthday ? "is-invalid" : ""}`}
          value={curiorInfo.birthday}
          onChange={(e) =>
            setCuriorInfo({ ...curiorInfo, birthday: e.target.value })
          }
        />
        {errorsForm?.birthday && (
          <small className="d-block invalid-feedback">
            {errorsForm.birthday}
          </small>
        )}
      </div>
      <div className="col-12">
        <label className="form-label">رقم الحساب المصرفي </label>
        <input
          type="text"
          className="form-control"
          value={curiorInfo.iban}
          onChange={(e) =>
            setCuriorInfo({ ...curiorInfo, iban: e.target.value })
          }
        />
      </div>

      <div className="col-12">
        <label htmlFor="" className="form-label">
          {" "}
          المتجر
        </label>
        {/* <EnhancedSearchStore setStoreId={setStoreId} value={mode ==="edit"?{id:curiorInfo?.store?.id , name:curiorInfo?.store?.name}: ""}/> */}
        <select
          name=""
          id=""
          className={`form-select ${errorsForm?.store_id ? "is-invalid" : ""}`}
          value={curiorInfo.store_id}
          onChange={(e) => {
            setCuriorInfo({
              ...curiorInfo,
              store_id: e.target.value === "" ? "" : +e.target.value,
            });
          }}
        >
          <option value=""> اختر المتجر</option>
          {delivery_company.map((shipping) => (
            <option key={shipping.id} value={shipping.id}>
              {shipping.name}
            </option>
          ))}
        </select>
        {errorsForm?.store_id && (
          <small className="d-block invalid-feedback">
            {errorsForm.store_id}
          </small>
        )}
      </div>

      <h5 className="fs-5 mt-3">
تعليمات  رفع الصورة
      </h5>
<div className="small text-muted mt-2">
  <div className="fw-bold">📷 الصيغ المسموحة: {imageInstructions.formats}</div>
  <div className="fw-bold">💾 الحد الأقصى للحجم: {imageInstructions.maxSize}</div>
 
</div>
      {/* صورة السائق */}
      <div className="col-xl-4">
        <label className="form-label">صورة السائق</label>
        <div
          className="flex-grow-1 border rounded-4 text-center p-4 upload-box"
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => avatarRef.current.click()}
        >
          <ArrowTop />
          <h6 className="fw-bold mb-1">تحميل صورة السائق</h6>
          <p className="text-muted small">(JPG / PNG) ارفع صورة بجودة عالية</p>
          <p className="text-muted small">الأبعاد 1:1</p>
          <p className="text-green"> {curiorInfo?.avatar?.name} </p>
          <input
            type="file"
            accept="image/png, image/jpeg"
            hidden
            ref={avatarRef}
            onChange={(e) => {
              const file = e.target.files[0];

              if (!validateImage(file)) return;

              setCuriorInfo((prev) => ({
                ...prev,
                avatar: file,
              }));
            }}
          />

          {curiorInfo.avatar && (
            <img
              width={50}
              height={50}
              src={
                curiorInfo.avatar instanceof File
                  ? URL.createObjectURL(curiorInfo?.avatar)
                  : curiorInfo?.avatar
              }
            />
          )}
          {errorsForm?.avatar && (
            <small className="d-block invalid-feedback">
              {errorsForm.avatar}
            </small>
          )}
        </div>
      </div>

      {/* الهوية الأمامية */}
      <div className="col-xl-4">
        <label className="form-label">صورة الهوية</label>
        <div
          className="flex-grow-1 border rounded-4 text-center p-4 upload-box"
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => frontIdRef.current.click()}
        >
          <ArrowTop />
          <h6 className="fw-bold mb-1">تحميل صورة الهوية من الجهة الأمامية</h6>
          <p className="text-muted small">(JPG / PNG) ارفع صورة بجودة عالية</p>
          <p className="text-muted small">الأبعاد 1:1</p>
          <p className="text-green"> {nationalID?.front_image?.name} </p>
          <input
            type="file"
            accept="image/png, image/jpeg"
            hidden
            ref={frontIdRef}
            onChange={(e) => {
              const file = e.target.files[0];

              if (!validateImage(file)) return;

              setNationalID((prev) => ({
                ...prev,
                front_image: file,
              }));
            }}
          />
          {nationalID.front_image && (
            <img
              width={50}
              height={50}
              src={
                nationalID.front_image instanceof File
                  ? URL.createObjectURL(nationalID.front_image)
                  : nationalID.front_image
              }
            />
          )}
          {errorsForm?.front_image && (
            <small className="d-block invalid-feedback">
              {errorsForm.front_image}
            </small>
          )}
        </div>
      </div>

      {/* الهوية الخلفية */}
      <div className="col-xl-4">
        <label className="form-label">صورة الهوية</label>
        <div
          className="flex-grow-1 border rounded-4 text-center p-4 upload-box"
          style={{ cursor: "pointer", minWidth: "250px" }}
          onClick={() => backIdRef.current.click()}
        >
          <ArrowTop />
          <h6 className="fw-bold mb-1">تحميل صورة الهوية من الجهة الخلفية</h6>
          <p className="text-muted small">(JPG / PNG) ارفع صورة بجودة عالية</p>
          <p className="text-muted small">الأبعاد 1:1</p>
          <p className="text-green"> {nationalID?.back_image?.name} </p>
          <input
            type="file"
            accept="image/png, image/jpeg"
            hidden
            ref={backIdRef}
            onChange={(e) => {
              const file = e.target.files[0];

              if (!validateImage(file)) return;

              setNationalID((prev) => ({
                ...prev,
                back_image: file,
              }));
            }}
          />{" "}
          {nationalID.back_image && (
            <img
              width={50}
              height={50}
              src={
                nationalID.back_image instanceof File
                  ? URL.createObjectURL(nationalID.back_image)
                  : nationalID.back_image
              }
            />
          )}
          {errorsForm?.back_image && (
            <small className="d-block invalid-feedback">
              {errorsForm.back_image}
            </small>
          )}
        </div>
      </div>
    </div>
  );
};

export default CuriorInfo;
